import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import SpinWheel from "./SpinWheel/SpinWheel";
function FreeSpin() {
  const navigate = useNavigate();
   const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  return (
    <div className="App">
      <div id="cricket-page-wrapper" className="spin-page-wrapper">
        <button
          type="button"
          aria-label="Back"
          className="spin-back-btn"
          onClick={() => navigate(-1)}
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="iframe-container">
          <SpinWheel profileData={profileData} />
        </div>
      </div>
    </div>
  );
}

export default FreeSpin;
